import React, { useEffect, useRef } from 'react';
import './home.css'
import { VedioPlaySvg } from '../../../../../../assets/svg/sidemenu/vedioPlaySVG.js';
import { StepperActiveSvg } from '../../../../../../assets/svg/sidemenu/home_stepper_active.js';
import { FlareSvg } from '../../../../../../assets/svg/sidemenu/flareSvg.js';
import { ReactComponent as HomeFooterSVG } from '../../../../../../assets/svg/sidemenu/homeNavSvg.svg';
import { ReactComponent as AbstractHalftoneDots } from '../../../../../../assets/svg/sidemenu/abstract_halftone_dots.svg';
import { ReactComponent as CurrentStepper } from '../../../../../../assets/svg/sidemenu/current_stepper.svg';
import ReactPlayer from 'react-player'
import { useDispatch, useSelector } from 'react-redux';
import { setGuideVisible, setStepIndex } from '../../../../../../stateManager/store/onboarding/action';
import { useHistory } from 'react-router-dom';
import { AppState } from '../../../../../../stateManager/store';
import HomeQuickActions from './HomeQuickActions';
import { Icon, Spin } from 'antd';
import style from "../../../../../apps/list.module.sass";
import { updateOnboarding } from '../../../../../../helpers/onboardingHelper';
import { Http } from '../../../../../../helpers/axois';
import { setOrgList } from '../../../../../../stateManager/store/orgs/actions';
import { updateAppsList } from '../../../../../../stateManager/store/apps/actions';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;


type HomeProps = {

};
let stepperList = [
    {
        id: "app",
        title: "Start Your App",
        caption: "This step focuses on setting up a basic application within A8Studio."
    },
    {
        id: "journey",
        title: "Create A Journey for Your App",
        caption: "Here, you'll design the specific workflow your application will follow using BPMN notation.",
    },
    {
        id: "first_form",
        title: "Create Your Forms",
        caption: "This step involves building the UI elements for users to interact with your application."
    },
    {
        id: "service",
        title: "Create your Services",
        caption: "This focuses on the automated service tasks your application will perform."
    },
    {
        id: "deploy",
        title: "Release your App",
        caption: "Finally, you prepare your application for deployment by defining the release version."
    }
]
const Home: React.FC<HomeProps> = ({ }) => {

    const videoRef = useRef<any>();
    const dispatch = useDispatch();
    const history = useHistory();
    const { info = {}, guideVisible, loading } = useSelector((state: AppState) =>  state.onboarding)
    const {selectedOrg} = useSelector((state: AppState) => state.org)
    const currentOrganizationId = useSelector((state: any) => {
        return state.org.selectedOrg.id || state.uiState?.selectedOrg?.[state.user.data.user.id]
    })
    
    const { stageIndex, guideCompleted, isExistServiceTask } = info;
    const user = useSelector((state: AppState) => state.user.data.user)
    const getApps = (orgId: string) => {
        Http.get(`org/${orgId}/apps`).subscribe((appRes: any) => {
            if (appRes) {
                dispatch(updateAppsList(appRes))
            }
        }, (err) => {
            console.error("failed to fetch apps", err);
        });
    }

    useEffect(()=>{
        if (!isExistServiceTask) {
            stepperList = stepperList.filter((stepList: any) => stepList.id !== 'service');
        } else if (!stepperList.some((stepList: any) => stepList.id === 'service')) {
            stepperList.splice(3,0, {
                id: "service",
                title: "Create your Services",
                caption: "This focuses on the automated service tasks your application will perform."
            })
        }
    },[isExistServiceTask])

    const getOrgs = () => {
        Http.get("/orgs/list").subscribe(
            (res: any) => {
              dispatch(setOrgList({
                orgList: res
              }))
              if (res && res.length) {
                const currentOrg = res.find((org: any) => org.id === currentOrganizationId)
                if (currentOrg && currentOrg.id) {
                    getApps(currentOrg.id);
                } else {
                    getApps(res[0].id);
                }
              }
            },
            (err) => {
                console.error("failed to fetch organizations", err)
            }
        );
    }

    useEffect(()=>{
        if (selectedOrg.id) {
            getApps(selectedOrg.id)
        } else {
            getOrgs();
        }
    },[])
    
    const handleTour = ()=> {
        let ms = 0;
        const { appId, appType, flowId, formId, isV2, serviceId, bpmnCheckout } = info;
        let type = appType === "a8solo" ? "solo" : "assist"
        let v2 = isV2 ? "v2" : "";
        if (stageIndex === 0) {
            history.push("/apps/list")
        } else if (stageIndex === 1 && appId) {
            if (bpmnCheckout) {
                history.push(`apps/list/${appId}/journey/${type}/list/${flowId}/create`)
                console.log(`apps/list/${appId}/journey/${type}/list/${flowId}/create`)
            } else {
                history.push(`apps/list/${appId}/journey/${type}/list`)
            }
        } else if (stageIndex === 2 && appId) {
            dispatch(setStepIndex(0))
            history.push(`apps/list/${appId}/${type}/forms/list`)
        } else if (stageIndex === 3 && appId) {    
            dispatch(setStepIndex(0))
            history.push(`apps/list/${appId}/assist/service/list`)
        } else if (stageIndex === 4 && appId) {
            history.push(`apps/list/${appId}/assist/deploy/list`)
        }
        setTimeout(() => {
            dispatch(setGuideVisible(true))
        }, ms)
    }

    const handleSkip = () => {
        const payload = {
            ...info,
            skipTour: true
        }
        updateOnboarding(user.userName, payload)
        dispatch(setGuideVisible(false))
    }

    // for uniphore apps redirect
    useEffect(() => {
        history.push('/apps')
    }, [])

    if (loading) {
        return (
            <div className={style.loadingSpinner}>
                <Spin indicator={antIcon} style={{ color: '#15808C' }} />
            </div>
        )
    }

    if ((stageIndex === stepperList.length && guideCompleted) || (!info || info.skipTour || (!info.guideCompleted && !info.level))) {
        return <HomeQuickActions getApps={getApps}></HomeQuickActions>
    }
    return (
        <div className='studio_home_cont'>
            <QuickStartGuideNav />
            <div className='home_main_cont'>
                <div className='home_main_vedio_cont'>
                    <div className='home_main_vedio_outter'>
                        <div className='home_main_vedio'>
                             <ReactPlayer
                                className='react-player'
                                url='https://www.youtube.com/watch?v=K7WOTF9gRN8'
                                width='100%'
                                height='100%'
                                controls={true}
                                light={true}
                                ref={videoRef}
                            />
                        </div>
                    </div>
                    <div className='flareSvg_1'>
                        <FlareSvg></FlareSvg>
                    </div>
                    <div className='flareSvg_2'>
                        <FlareSvg height={"19px"} width={"19px"}></FlareSvg>
                    </div>
                    <div className='flareSvg_3'>
                        <FlareSvg height={"22px"} width={"22px"}></FlareSvg>
                    </div>
                    <div className='abstract_halftone_dots_svg'>
                        <AbstractHalftoneDots />
                    </div>
                </div>
                <div className='home_main_content_cont'>
                    <div className='home_vedio_content_tle'>
                        <h2>Get Started with Your App</h2>
                    </div>
                    <div className='home_vedio_content_dcpn'>
                        <span>
                            Create an A8Flow app to automate tasks and processes, saving you time and effort! A8Flow apps let you build custom workflows that streamline your work. You can design these workflows to handle repetitive tasks, collect data from users, and even make decisions based on specific conditions.
                        </span>
                    </div>
                    <div className='home_vedio_content_btn'>
                        <button onClick={handleSkip} className='skip_tour'>Skip Tour</button>
                        <button onClick={handleTour}>Get Started</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const QuickStartGuideNav = () => {

    const { stageIndex } = useSelector((state:AppState) => state.onboarding.info)
   
    return (
        <div className='home_guide_nav'>
            <div className='home_guide_nav_head' key={"home_guide_nav"}>
                <h4 className='home_guide_nav_title'>A Quick-Start Guide to A8Studio</h4>
                <div className='home_guide_nav_content'>
                    <span>
                        <VedioPlaySvg />
                    </span>
                    <div className='home_guide_nav_cont_inner'>
                        <span>Watch A Video Preview</span>
                        <p>5 Minutes</p>
                    </div>
                </div>
            </div>
            <div className='home_guide_nav_stepper_cont'>
                {
                    stepperList.map((stepper,i) => {
                        return (
                            <div className="home_guide_stepper">
                                <div>
                                    <div className={`home_guide_stepper_circle ${stageIndex > i ? "home_guide_stepper_circle_active": ""}`}>
                                        {stageIndex !== i && <StepperActiveSvg circleColor={stageIndex > i ? "#F1722E": "#7D8492"} />}
                                         {stageIndex === i && <CurrentStepper/>}
                                    </div>
                                   
                                </div>
                                <div>
                                    <div className="home_guide_stepper_tle">{stepper.title}</div>
                                    <div className="home_guide_stepper_cpn">{stepper.caption}</div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <div className='home_guide_nav_footer'>
                <HomeFooterSVG />
            </div>
        </div>
    )
}
export default Home;
